import { saveConfigs } from '../../../ConfigState/ConfigState.actions';
export var submitUpiPaymentMethod = function submitUpiPaymentMethod(dispatch) {
  dispatch(saveConfigs({
    submit: true
  }));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/CommandState/commands/helpers/submitUpiPaymentMethod.js
// module id = 4522
// module chunks = 11